<template>
  <div class="referral-chain" @touchmove.stop="closeShowTips">
    <ul>
      <template v-for="(item, index) in referralChainInfo" >
        <li :key="'hardlink' + index">
          <div v-if="index - 1 <= selfIndex && index > 0" class="referral-icon">
            <span class="iconfont icona-hardlink"></span>
          </div>
          <div v-if="index - 1 > selfIndex" class="referral-icon">
            <span class="iconfont icona-softlink"></span>
          </div>
        </li>
        <li :key="index">
          <div class="candidate-info" style="--breath-color: #0096cc">
            <div :class="index === (referralChainInfo.length - 1) && 'breath-animation'">
              <img
                class="referral-chain-photo"
                :class="{ self: index === (referralChainInfo.length - 1) }"
                :src="[item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url]"
                @error.once="getDefaultProfilePhoto($event)"
              />
            </div>
            <span class="candidate-name" :title="item.name">{{ item.name }}</span>
            <span class="city" :title="getI18nPropertyValue(item.city, 'cn_name', 'name')">{{ getI18nPropertyValue(item.city, 'cn_name', 'name') }}</span>
            <div class="personal-referral-chain-role-type">
              <span :title="getRoleTypeText(item, index)">{{ getRoleTypeText(item, index) }}</span>
            </div>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { getI18nPropertyValue } from '@/i18n'

const ROLE_TYPE = {
  LEAD: 'Lead',
  EMPLOYEE: 'Employee',
  PROSPECT: 'Prospect'
}

export default {
  directives: {
    Clickoutside
  },
  props: {
    referralChainInfo: {
      type: Array,
      require: true
    },
    isPotential: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      getI18nPropertyValue,
      selfIndex: 2,
      showTips: false,
      showTipsIndex: null
    }
  },
  computed: {

  },
  created () {
    this.referralChainInfo.forEach((element, index) => {
      if (element.self === true) {
        this.selfIndex = index
      }
    })
  },
  methods: {
    getRoleTypeText (info, index) {
      const type = info.type
      let i18nKey
      const isLast = index === (this.referralChainInfo.length - 1)
      if (isLast) {
        if (this.isPotential) {
          i18nKey = type === ROLE_TYPE.LEAD ? 'lead' : 'prospect'
        } else {
          i18nKey = type === ROLE_TYPE.EMPLOYEE ? 'employee' : 'candidate'
        }
      } else {
        if (type === ROLE_TYPE.EMPLOYEE) {
          i18nKey = 'employee'
        } else if (!this.isPotential && type === ROLE_TYPE.LEAD) {
          i18nKey = 'lead'
        } else {
          i18nKey = 'candidate'
        }
      }
      return this.$t(`hm.resume.referralRoleType.${i18nKey}`)
    },
    closeShowTips (index) {
      if (this.showTips && index === this.showTipsIndex) {
        this.showTips = false
      }
      this.$emit('closeShowTips')
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-chain {
  padding-top: 2px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(204, 211, 211, 1);
    background: rgba(152, 155, 163, 0.5);
  }

  >ul {
    display: flex;
    align-items: flex-start;

    .referral-icon {
      height: 40px;
      line-height: 40px;
      position: relative;
      margin-top: 4px;
      margin-bottom: 43px;

      > span {
        font-size: 40px;
        color: #0096cc;
      }
    }

    > li {
      text-align: center;
      display: flex;
      max-height: 120px;
      margin-bottom: 5px;
      padding: 0px 5px 0px 5px;

      .candidate-info {
        display: flex;
        flex-direction: column;
        align-items: center;

        > div {
          margin-top: 2px;
          border-radius: 50%;
          height: 40px;
        }

        .referral-chain-photo {
          border: 1px solid white;
          border-radius: 50%;
          width: 38px;
          height: 38px;
          box-shadow: 2px 1px 4px 0px #a8b2b5;
          z-index: 1;
        }

        .self {
          box-shadow: 0 0 0px 2px #0296cc;
        }

        span {
          font-size: 12px;
          white-space: nowrap;
          width: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 400;
          line-height: 16px;
          margin: 0px;
        }

        .candidate-name {
          color: #060101;
          font-size: 12px;
          font-weight: bold;
          margin-top: 5px;
          line-height: 1.5;
        }

        .city {
          height: 16px;
        }

        .personal-referral-chain-role-type {
          display: flex;
          max-height: 18px;
          width:70px;
          padding: 0 2px;
          text-align: center;
          white-space: nowrap;
          justify-content: center;
          align-items: center;
          border: 1px solid #BABDC5;
          border-radius: 0;

          .referral-chain-photo {
            width: 40px;
            height: 40px;
            border-radius: 0;
            box-shadow: 0;
            -webkit-box-shadow: 0;
          }

          > p {
            height: 14px;
            font-size: 10px;
            font-weight: 500;
            line-height: 14px;
            margin-top: 5px;
          }

          .iconfont {
            &.email {
              color: #0296cc;
              font-size: 16px;
            }
          }

          > span {
            margin-left: 3px;
            width: auto;
            color: #909399;
            line-height: 16px;
          }
        }
      }
    }
  }

  .breath-animation {
    box-shadow: 0 0 10px -3px var(--breath-color);
    animation: breath 3s linear infinite;
  }

  @keyframes breath {
    from {
      opacity: .8;
      box-shadow: 0 0 10px -3px var(--breath-color);
    }
    25% {
      box-shadow: 0 0 9px 0px var(--breath-color);
    }
    50% {
      opacity: 1;
      box-shadow: 0 0 8px 2px var(--breath-color);
    }
    75% {
      box-shadow: 0 0 9px 0px var(--breath-color);
    }
    to {
      opacity: .8;
      box-shadow: 0 0 10px -3px var(--breath-color);
    }
  }
}
</style>
